// ** Angular Import
import { CommonModule } from '@angular/common';
import { Component, ContentChild, inject, Input, TemplateRef } from '@angular/core';

// ** Custom Component Import
import { ButtonComponent } from '@shared/components/core/button/button.component';

// ** Services Import
import { WebsiteService } from '@shared/services/website.service';

// Third-Party Imports
import { TranslocoModule } from '@jsverse/transloco';

// ** Types Import
import { ButtonConfig, ButtonRoute } from '@shared/components/core/button/button.types';


@Component({
  selector: 'app-section-heading',
  templateUrl: './section-heading.component.html',
  imports: [CommonModule, ButtonComponent, TranslocoModule]
})

export class SectionHeadingComponent {
  websiteService = inject(WebsiteService);

  @Input() title?: string = '';
  @Input() titleClasses?: string = '';
  @Input() subtitle?: string = '';
  @Input() subtitleClasses?: string = '';
  @Input() description?: string = '';
  @Input() descriptionClasses?: string = '';
  @Input() titleButtonClasses?: string = '';
  @Input() button?: {
    route?: ButtonRoute;
    onClick?: any;
    buttonConfig?: ButtonConfig;
  };
  @Input() buttonClasses?: string = '';
  @Input() buttonPosition?: 'inline' | 'below' = 'inline';
  @Input() alignment?: 'center' | 'left' = 'left';

  @ContentChild('customButton', { read: TemplateRef }) customButtonTemplate?: TemplateRef<any>;

  get mergedButtonConfig() {
    return {
      type: 'primary',
      ...(this.button?.buttonConfig || {})
    } as ButtonConfig;
  }
}
